import { ApolloClient, createHttpLink, InMemoryCache } from "@apollo/client";
import { getXsrfToken } from "../../utils/xsrfTokenStore.ts";
import { setContext } from "@apollo/client/link/context";

const httpLink = createHttpLink({
  uri: "/graphql", // e.g., /graphql
});

const authLink = setContext((_, { headers }) => {
  // Get the XSRF token from the shared store
  const token = getXsrfToken();

  // Return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      "X-XSRF-TOKEN": token ? token : "", // Or 'X-CSRF-TOKEN', ensure it's not undefined
    },
  };
});

export const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});
